// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"87ba845d","151":"eff464b5","326":"c5859827","374":"bdf35565","420":"e8d5aa2c","609":"13e9b30d","810":"7fc32d4b","864":"3a95f5ce","947":"41c8b9a2"}[chunkId] + ".chunk.js";
};